import './index.css';
import 'dayjs/locale/ko'; // 한국어
import 'dayjs/locale/en'; // 영어
import 'dayjs/locale/de'; // 독일어
import './utils/api-debug';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { LicenseInfo } from '@mui/x-license';

import App from './App';
import reportWebVitals from './reportWebVitals';

// MUI X Pro 라이센스 키 설정
LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_PRO_LICENSE_KEY || '');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
